import React, { Fragment, useEffect, useState } from 'react'
import CustomizedDialogs from '../../atoms/dialog'
import { Button, Checkbox, CircularProgress, FormControlLabel, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useForm } from 'react-hook-form';
import { validateBlueprintName } from '../bluePrintComponents/SystemModel/helpers';
import { handleSnackBar, invokePostService, setReRender } from '../../../store/global/actions';
import { useDispatch } from 'react-redux';
import { IconSelector } from '../../atoms/IconSelectorV2';
import { findIconSource, formatFetchedCustomIcons, generateIconFileName } from '../../../utils/commonUtils';

export default function BlueprintEditDialog({isOpen=false, setActiveDialog, blueprint_id, slug, selectedItem, setSelectedItem, setIconSource }) {
	const iconPath = `/blueprintAssets/${blueprint_id}_${slug}/`
	const dispatch = useDispatch();
    const [open, setOpen] = useState(isOpen);
	const [renameLoader, setRenameLoader] = useState(false);
	const { register, getValues, reset, trigger, errors, watch } = useForm();
	const [validationError, setValidationError] = useState("");
	const [icon, setIcon] =useState(formatFetchedCustomIcons(selectedItem, iconPath) || null);
    
	const [isAutofill, setIsAutofill] = useState(false);
	const [isAutocapture, setIsAutocapture] = useState(false);
    
	const current_name = watch("name");

	const toggleRenameConfirmation = (event) => {
        if(open){
            setActiveDialog(null)
        }
        setOpen((prev) => !prev)
    };

	useEffect(() => {
		let defaultValues = {};
		defaultValues.name = selectedItem.name;
		defaultValues.description = selectedItem.description
		reset({ ...defaultValues });

		setIcon(formatFetchedCustomIcons(selectedItem, iconPath));

		if(selectedItem.configuration){
			setIsAutofill(selectedItem.configuration.autoFill)
			setIsAutocapture(selectedItem.configuration.autoCapture)
		}
	}, [selectedItem]);


	const onRename = (event) => {
		
		setRenameLoader(true);
		trigger().then((result) => {
			const { name, description } = getValues();
			if (!result) {
				const validateName = validateBlueprintName(name);
				if (validateName?.length) {
					setValidationError(validateName);
				}
				setRenameLoader(false);
				return;
			}

			let icon_payload = {};
			if(icon){
				icon_payload.icon = generateIconFileName(icon);
				icon_payload.iconSource = findIconSource(icon);
			}
			console.log({icon_payload})

			const configuration = {
				autoFill: isAutofill,
				autoCapture: isAutocapture
			}

			dispatch(invokePostService('renameBlueprint', { name, description, configuration, icon: icon_payload, blueprintId: selectedItem._id })).then(res => {
				setRenameLoader(false);
				if (res?.status === true) {
					setIcon(formatFetchedCustomIcons(res?.data, iconPath));
					setIconSource(formatFetchedCustomIcons(res?.data, iconPath));
					setSelectedItem(res?.data || null);
					dispatch(handleSnackBar({ open: true, message: res.message, severity: "success" }));
					toggleRenameConfirmation();
					dispatch(setReRender());
                    setActiveDialog(null)
                } else {
					setValidationError(res.message)
				}

			});
		});

	};


  return (
        <CustomizedDialogs
				container_id="blueprint-edit-container"
				open={open}
				title="Edit Blueprint"
				handleClose={toggleRenameConfirmation}
				actions={
					<React.Fragment>
						<Button onClick={toggleRenameConfirmation} variant="outlined" color="primary" style={{textTransform: 'capitalize'}}>
							Close
						</Button>
						<Button
							id="updateBlueprint"
							variant="contained"
							color="primary"
							onClick={onRename}
							disabled={renameLoader}
							startIcon={renameLoader ? <CircularProgress color="secondary" size={20} /> : <Fragment />}
							style={{textTransform: 'capitalize'}}
						>
							{renameLoader ? 'Updating..' : 'Update'}
						</Button>
					</React.Fragment>
				}
			>
				{validationError !== '' && <Alert severity="error" style={{ marginBottom: 20 }}>{validationError}</Alert>}
				<TextField
					InputLabelProps={{
						shrink: true,
					}}
					fullWidth
					required
					label={"Title"}
					variant="outlined"
					name="name"
					autoFocus={true}
					error={Boolean(errors.name)}
					// helperText={<LabelHelperText control={control} />}
					inputRef={register({ required: true, validate: validateBlueprintName })}
				/>

				&nbsp;&nbsp;

				<TextField
					style={{marginBottom: '10px'}}
					id="description"
					InputLabelProps={{
						shrink: true,
					}}
					// error={Boolean(errors?.description)}
					type={"text"}
					fullWidth
					rows={4}
					multiline={true}
					label={"Description"}
					placeholder={"Description"}
					variant="outlined"
					name="description"
					inputRef={register}
				/>
				
				<IconSelector blueprint_id={blueprint_id} slug={slug} setSelectedIcon={setIcon} selectedIcon={icon} entityType={'view'}  defaultSearchTag={current_name || ""}/>


				<FormControlLabel className="autoFill"
					control={
						<Checkbox checked={isAutofill} onChange={e => setIsAutofill(e.target.checked)}  name={"autoFill"} />
					}
					label="Autofill"
				/>
				<FormControlLabel className="autoCapture"
					control={
						<Checkbox checked={isAutocapture} onChange={e => setIsAutocapture(e.target.checked)}  name={"autoCapture"}/>
					}
					label="Auto capture"
				/>

			</CustomizedDialogs>
  )
}
